<script>
import DailyRain from "@/views/count/safe/DailySafe.vue";

export default {
  name: "rain",
  components: { DailyRain},
  data() {
    return {
      period: 'hdsq'
    }
  },
  methods: {
    init() {
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<template>
  <el-container style="padding: 10px;">
    <div style="width: 100%;height: 5vh;background-color: white">
      <daily-rain></daily-rain>
    </div>
  </el-container>
</template>

<style scoped>
/* 按钮样式 */
::v-deep .queryButton {
  font-family: PingFang SC;
  font-size: 1.4rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  border-radius: 0.5rem;
  margin-left: 1.5rem;
}

::v-deep .queryButtonPadding {
  padding-left: 2rem;
  padding-right: 2rem;
}

::v-deep .qDcBtn {
  position: absolute;
  right: 4rem;
}

::v-deep .qDcImg {
  width: 1.2rem;
  height: 1.2rem;
}
</style>
